import { useCallback, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CustomPagination from "../../components/CustomPagination";
import * as CustomToast from "../../components/CustomToastMessage";
import NoDateFound from "../../components/NoDateFound";
import Loader from "../../components/loader/Loader";
import axiosInstance from "../../utils/axiosConfig";

function RedemptionsUsersListViewModel({ show, toggleModelVisibility, data }) {
  const [usersState, setUsersState] = useState({
    loading: true,
    users: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
    },
  });
  const PAGE_LIMIT = 10;
  const TABLE_COLUMN_LENGTH = 3;

  const handleClose = () => {
    toggleModelVisibility("redemptionsUsersList");
  };

  const fetchRedemptionsUsersList = useCallback(async (filterData = {}) => {
    const { page = 1, limit = PAGE_LIMIT, promoCode = "" } = filterData;
    try {
      setUsersState((prev) => ({ ...prev, loading: true }));
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/promo-code/usage/users`,
        {
          params: {
            page,
            limit,
            promoCode,
          },
        }
      );
      
      if (response.data.success) {
        setUsersState((prev) => ({
          ...prev,
          loading: false,
          users: response.data.data,
          pagination: response.data.pagination,
        }));
      } else {
        setUsersState((prev) => ({
          ...prev,
          loading: false,
          users: [],
          pagination: {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
          },
        }));
      }
    } catch (error) {
      setUsersState((prev) => ({
        ...prev,
        loading: false,
        users: [],
      }));

      if (error.response.data.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Internal server error");
    } finally {
      setUsersState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  }, []);

  useEffect(() => {
    if (data) {
      fetchRedemptionsUsersList({
        page: 1,
        limit: PAGE_LIMIT,
        promoCode: data?.code,
      });
      // Fetch the redemption users list using the provided data
    }
  }, [data]);

  const handlePageChange = (page) => {
    fetchRedemptionsUsersList({
      page,
      limit: PAGE_LIMIT,
      promoCode: data?.code,
    });
  };

  return (
    <>
      <Modal
        show={show}
        className="custom-modal"
        size="lg"
        // centered
        scrollable
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <Modal.Title>View User Redemption List</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body">
            <div className="overflow-auto">
              <Table className="vertical-align">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Email</th>
                    <th>Name</th>
                    {/* <th>Purchase Date</th>
                    <th>Expire Date</th> */}
                    {/* <th>Created Date</th> */}
                  </tr>
                </thead>
                <tbody>
                  {usersState.loading ? (
                    <tr>
                      <td colSpan={TABLE_COLUMN_LENGTH} className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : usersState.users.length > 0 ? (
                    usersState.users.map((user, index) => (
                      <tr key={user._id}>
                        <td>
                          <p className="mb-0">
                            {(usersState.pagination.currentPage - 1) *
                              usersState.pagination.limit +
                              index +
                              1}
                          </p>
                        </td>
                        <td>{user.email ? user.email : "-"}</td>
                        <td className="table-td-200">
                          {user.firstName
                            ? user.lastName
                              ? user.firstName + " " + user.lastName
                              : user.firstName
                            : "-"}
                        </td>
                        {/* <td className="table-td-130">
                          {user?.purchaseDate
                            ? new Date(user.purchaseDate)
                                .toISOString()
                                .split("T")[0]
                            : "-"}
                        </td>
                        <td className="table-td-130">
                          {user?.expiryDate
                            ? new Date(user.expiryDate)
                                .toISOString()
                                .split("T")[0]
                            : "-"}
                        </td> */}
                        {/* <td className="table-td-130">
                          {user.createdAt
                            ? new Date(user.createdAt)
                                .toISOString()
                                .split("T")[0]
                            : "-"}
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={TABLE_COLUMN_LENGTH} className="text-center">
                        <NoDateFound subMessage="" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {usersState.pagination.totalPages > 1 && !usersState.loading && (
              <CustomPagination
                currentPage={usersState.pagination.currentPage}
                totalPages={usersState.pagination.totalPages}
                totalItems={usersState.pagination.totalItems}
                limit={usersState.pagination.limit}
                onPageChange={(page) => handlePageChange(page)}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RedemptionsUsersListViewModel;
